<template>
	<div class="mt-1 mb-1 cursor-pointer">
		<div class="cursor-pointer" @click="openTab()"><label class="label-title">{{label}}</label><a class="float-right pointer" :class="{'rotate-90': show_list}">&#9656;</a></div>
		<ul v-if="show_list">
			<li :class="{'selected_item': selected_id.includes(custom_li.id)}" v-for="(custom_li,index) in accessList" :key="index">
				<p @click="selectItem(custom_li)">{{custom_li.name}}<a class="float-right" v-if="custom_li.subgroups && custom_li.subgroups.length > 0">&#9656;</a></p>
				<ul :class="{'selected_item': selected_id.includes(custom_li.id)}" class="dropdown" v-if="custom_li.subgroups && custom_li.subgroups.length > 0">
					 <recursion-list-user v-for="(custom_sub,index_) in custom_li.subgroups" :custom_sub="custom_sub" :selected_id="selected_id" :index_="index" :key="index_" @selectItem="selectItem" />
					<!-- <li :class="{'selected_item': selected_id.includes(custom_sub.id)}" v-for="(custom_sub,index) in custom_li.subgroups" :key="index"
					@click="selectItem(custom_sub)">
						<p>{{custom_sub.name}}</p>
					</li> -->
				</ul>
			</li>
		</ul>
		<hr>
	</div>
</template>
<script>
import recursionListUser from './recursionListUser.vue'
export default {
	components : {
		recursionListUser
	},
	props:{
		label:String,
		// type: String,
		selected_id: Array,
		accessList: Array,
		selection: Object
	},
	data : function(){
		return{
			show_list: false
		}
	},
	mounted: function(){
		if(this.selection != null || this.selection != {}){
			if(this.selection.type == this.label){
				this.show_list = true
			}
		}
	},
	methods:{
		openTab(){
			this.show_list = !this.show_list
		},
		selectItem(elem){
			this.$emit("selectItem", elem)
		}
	}
	
}
</script>
<style scoped src="../shared/assets/css/accessList.css">

</style>



// WEBPACK FOOTER //
// src/components/shared/ListViewAccess.vue